<template>
  <b-card>
    <b-row>
      <b-col
        cols="12"
        md="6"
      >
        <h4 class="card-title mb-0 pt-50">
          View Role User</h4>
      </b-col>
      <b-col
        cols="12"
        md="6 ml-auto"
      >
        <div class="d-flex align-items-center justify-content-end">
          <b-button
            variant="outline-secondary"
            @click="back"
          >
            Back
          </b-button>
        </div>
      </b-col>
    </b-row>
    <hr>

    <app-timeline>
      <app-timeline-item class="pb-1">
        <b-row class="mt-1">
          <b-col
            cols="12"
            md="6"
            lg="4"
          >
            <b-form-group>
              <label>Name</label>
              <span
                class="form-control"
                v-text="addRoleuser.name"
              />
            </b-form-group>
          </b-col>
          <b-col
            cols="12"
            md="6"
            lg="4"
          >
            <b-form-group>
              <label>Email</label>
              <span
                class="form-control h-auto"
                v-text="addRoleuser.email"
              />
            </b-form-group>
          </b-col>
          <b-col
            cols="12"
            md="6"
            lg="4"
          >
            <b-form-group>
              <label>User Type</label>
              <span
                class="form-control"
                v-text="addRoleuser.type"
              />
            </b-form-group>
          </b-col>
        </b-row>
        <b-row v-if="addRoleuser.type.toLowerCase() === 'admin'">
          <b-col cols="12">
            <b-alert
              variant="primary"
              show
            >
              <div class="alert-body">
                <span><strong>All Roles Selected</strong></span>
              </div>
            </b-alert>
          </b-col>
        </b-row>
      </app-timeline-item>

      <app-timeline-item
        v-if="addRoleuser.type.toLowerCase() === 'internal'"
        variant="info"
        class="pb-1"
      >
        <div class="d-flex flex-sm-row flex-column flex-wrap justify-content-between mb-1 mb-sm-0">
          <h6>Select Roles</h6>
        </div>
        <b-row
          v-for="(departmentDevision, index) in Object.keys(addRoleuser.devisions)"
          :key="index"
          :value="index"
          class="mt-1"
        >
          <b-col cols="12">
            <b-form-checkbox
              v-model="addRoleuser.devisions[departmentDevision].selected"
              class="custom-control-primary mb-1"
              disabled
              @input="departmentSelected(departmentDevision)"
            >
              {{ departmentDevision }}
            </b-form-checkbox>
          </b-col>
          <b-col
            cols="12"
            class="pl-5"
          >
            <b-row v-show="addRoleuser.devisions[departmentDevision].selected">
              <b-col
                v-for="(devision, newindex) in addRoleuser.devisions[departmentDevision]"
                :key="newindex"
                :value="newindex"
                cols="3"
              >
                <b-form-checkbox
                  v-model="devision.selected"
                  class="custom-control-primary mb-1"
                  disabled
                  @input="devisionSelected(departmentDevision, devision.selected)"
                >
                  {{ devision.name }}
                </b-form-checkbox>
              </b-col>
              <b-col cols="12">
                <hr>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </app-timeline-item>

      <app-timeline-item
        v-show="addRoleuser.user_defined_fields.length !== 0"
        variant="success"
        class="pb-1"
      >
        <div class="d-flex flex-sm-row flex-column flex-wrap justify-content-between mb-1 mb-sm-0">
          <h6>User Defined Fields</h6>
        </div>
        <b-row class="mt-1">
          <b-col
            v-for="field in addRoleuser.user_defined_fields"
            :id="field.id"
            :key="field.id"
            cols="12"
            md="6"
            lg="4"
          >
            <dl class="row">
              <dt class="col-sm-12 dt-text">
                {{ field.name }}
              </dt>
              <dd class="col-sm-12">
                <span
                  class="form-control h-auto"
                  v-text="field.value"
                />
              </dd>
            </dl>
          </b-col>
        </b-row>
      </app-timeline-item>
    </app-timeline>
  </b-card>
</template>

<script>
import {
  BCard, BRow, BCol, BFormGroup, BButton, BFormCheckbox, BAlert,
} from 'bootstrap-vue'
import AppTimeline from '@core/components/app-timeline/AppTimeline.vue'
import AppTimelineItem from '@core/components/app-timeline/AppTimelineItem.vue'
import RoleUser from '@/js/roleusers'

export default {
  name: 'RoleUserView',
  components: {
    BCard,
    AppTimeline,
    AppTimelineItem,
    BRow,
    BCol,
    BFormGroup,
    BFormCheckbox,
    BButton,
    BAlert,
  },
  directives: {
  },
  setup() {
  },
  data() {
    return {
      addRoleuser: {
        name: '',
        email: '',
        type: '',
        fa_expenses_devision: false,
        bs_devision: false,
        do_devision: false,
        st_devision: false,
        ta_devision: false,
        rc_devision: false,
        ji_devision: false,
        ii_devision: false,
        ti_devision: false,
        mc_devision: false,
        cc_devision: false,
        pd_devision: false,
        im_devision: false,
        mt_devision: false,
        cv_devision: false,
        cr_devision: false,
        cp_devision: false,
        cs_devision: false,
        ce_devision: false,
        am_devision: false,
        ae_devision: false,
        ai_devision: false,
        mp_devision: false,
        me_devision: false,
        mi_devision: false,
        reports_devision: false,
        forcast_devision: false,
        fa_vendor_devision: false,
        fa_referrer_devision: false,
        fa_supplier_devision: false,
        fa_subvendor_devision: false,
        fa_employer_devision: false,
        fa_timesheet_devision: false,
        hr_jobs_devision: false,
        hr_exception_devision: false,
        hr_interviews_devision: false,
        hr_onboarding_devision: false,
        hr_endclients_devision: false,
        hr_vendor_devision: false,
        hr_referrer_devision: false,
        hr_supplier_devision: false,
        hr_subvendor_devision: false,
        hr_employer_devision: false,
        hr_prospect_devision: false,
        hr_consultant_devision: false,
        hr_employee_devision: false,
        vjms_db_division: false,
        vjms_jr_division: false,
        vjms_vr_division: false,
        vjms_ms_division: false,
        vjms_ss_division: false,
        user_defined_fields: [],
      },
    }
  },
  mounted() {
  },
  created() {
    RoleUser.getRoleuserById(this, this.$route.params.id)
  },
  destroyed() {
  },
  methods: {
    setRoleuser(data) {
      this.addRoleuser = data
      Object.keys(this.addRoleuser.devisions).forEach(key => {
        Object.keys(this.addRoleuser.devisions[key]).forEach(devision => {
          if (this.addRoleuser.devisions[key][devision].selected === true) {
            this.addRoleuser.devisions[key].selected = true
          }
        })
      })
    },
    back() {
      this.$router.go(-1)
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-sweetalert.scss';
</style>
